import { type ITypeState } from "@interfaces/common/ITypeState";
import { CommonService } from "@services/common.service";
import { CommonStore } from "@state/common/common.store";
import { map } from "rxjs";

import { inject } from "@angular/core";
import { type ResolveFn } from "@angular/router";

export const typeStatesResolver: ResolveFn<ITypeState[]> = () => {
  const commonService = inject(CommonService);
  const commonStore = inject(CommonStore);

  return commonService.getTypeStates().pipe(
    map(states => {
      commonStore.setTypeState(states.data);
      return states.data;
    })
  );
};
